import React from "react";
import MainButton from "../button";

const Footer = ({
  onNext,
  onCancel,
  onBack,
  onFinish,
  item,
  itemDisabled,
}) => {
  return (
    <footer className="wizard-footer">
      {item?.isCancel && (
        <MainButton
          isDisabled={itemDisabled?.cancel}
          text="cancel"
          variant="error"
          onClick={onCancel}
          className="wizard-footer-item"
        />
      )}
      {item.isBack && (
        <MainButton
          isDisabled={itemDisabled?.back}
          text="Back"
          onClick={onBack}
          className="wizard-footer-item"
        />
      )}
      {item?.isNext && (
        <MainButton
          isDisabled={itemDisabled?.next}
          text="next"
          variant="success"
          onClick={onNext}
          className="wizard-footer-item"
        />
      )}
      {item?.isFinish && (
        <MainButton
          isDisabled={itemDisabled?.finish}
          text="finish"
          variant="success"
          onClick={onFinish}
          className="wizard-footer-item"
        />
      )}
    </footer>
  );
};

export default Footer;
